/**
 *
 * HowItWorksChooseFund
 */
import { Box, Typography } from '@mui/material';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import { homeStyles } from './home-styles';

export default function HowItWorksChooseFund() {
  return (
    <div>
      <Box sx={homeStyles.icons}>
        <ScreenSearchDesktopIcon fontSize="large" />
      </Box>
      <Typography
        color="primary"
        component="h5"
        variant="h5"
        sx={homeStyles.titles}
      >
        Choose a fund.
      </Typography>
      <Typography paragraph variant="body1" sx={homeStyles.descriptions}>
        Browse funds currently looking for items to be donated.
      </Typography>
    </div>
  );
}
